import { FC } from 'react';

export const GiftPrivacyNotice: FC = function GiftPrivacyNotice() {
  return (
    <div>
      <div className="flex justify-between">
        <h4 className="pb-3 font-bold">개인정보 취급방침에 대한 동의</h4>
      </div>
      <p className="p-4 pt-2 theme-text-8 theme-bg-1">
        <span className="flex h-12 items-center justify-start py-2 text-sm">
          아래 내용을 확인하였으며 결제에 동의합니다.
        </span>
        <span className="block font-bold leading-7 underline">개인정보 취급방침</span>
        <span className="whitespace-pre-line break-keep text-xs leading-[18px]">
          가온프라임(주)는 통신판매중개자로서, 입점판매자가 등록한 상품 정보 및 거래에
          대해 가온프라임(주)는 일체의 책임을 지지 않습니다.
        </span>
      </p>
    </div>
  );
};
